import React from 'react';
import './index.scss';
import { connect } from 'react-redux';
import Notifications from '../../../common/header/notifications';
import { REDUCER_NAME } from '../../reducer';

class NotificationsWrapper extends React.Component {
  render() {
    const { companyScore } = this.props;
    return <Notifications data={companyScore} />;
  }
}

const mapStateToProps = (state, { id }) => {
  return {
    i18n: state.i18n,
    companyScore: state[REDUCER_NAME].listMultiComponent[id].companyScore,
  };
};

export default connect(mapStateToProps)(NotificationsWrapper);
